module.exports = __webpack_public_path__ + "img/TZS09660.32ef2271.jpeg";